import { alpha } from '@mui/material'
import ThemeInterface from '@/theme-interface'

/**
 * Backdrop of every modal of the orgaMAX registration (confirm email, password, short question,
 * welcome): the dashboard behind it stays visible, darkened and blurred.
 * Usage: `backdrop: { ...registrationBackdrop(theme) }` + `slotProps={{ backdrop: { className: classes.backdrop } }}`
 */
export const registrationBackdrop = (theme: ThemeInterface) => ({
  background: alpha(theme.palette.brand.text.heading, 0.7),
  '@supports (backdrop-filter: blur(4px))': {
    backdropFilter: 'blur(4px)',
  },
})
